import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { history } from '../..';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Skeleton from '@material-ui/lab/Skeleton';
import CachedIcon from '@material-ui/icons/Cached';
import reactHtmlParser from 'react-html-parser';

import { tabRoutes } from '../../routes';
import { generateInputParamsAttributes } from './constants';
import { DIMENSIONS } from '../../styles/constants';
import { useTableRowStyles, useTableCellStyles } from '../Card/styles';
import OptionalParameters from './OptionalParameters';
import Card from '../Card';
import { useTranslation } from 'react-i18next';

const InputParameters = ({ inputParameters, withChangeButton, isVinNomSet }) => {
	const { t } = useTranslation();
	const tableRowClasses = useTableRowStyles({ isVinNomSet });
	const tableCellClasses = useTableCellStyles();
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const INPUT_PARAMS_ATTRIBUTES = generateInputParamsAttributes(inputParameters.supplyType);

	const handleChangeClick = () => {
		history.push(tabRoutes.find(route => route.name === 'Inputs').path);
	};

	return (
		<Card
			title={
				progressActive ? <Skeleton height={DIMENSIONS.SKELETON_TITLE_HEIGHT} /> : t('components.inputParameters.title')
			}
			titleAction={
				!progressActive &&
				withChangeButton && (
					<Tooltip title={t('components.inputParameters.buttonTooltip')}>
						<IconButton aria-label="Change Input Parameters" onClick={() => handleChangeClick()}>
							<CachedIcon />
						</IconButton>
					</Tooltip>
				)
			}
			actions={!progressActive && isVinNomSet && <OptionalParameters inputParameters={inputParameters} />}>
			<Table>
				<TableBody>
					{INPUT_PARAMS_ATTRIBUTES.map(attribute =>
						progressActive ? (
							<Skeleton height={DIMENSIONS.SKELETON_TEXT_HEIGHT} />
						) : (
							<TableRow key={'input-parameters-row-' + attribute.label} classes={tableRowClasses}>
								<TableCell classes={tableCellClasses}>
									<Typography variant="body2" color="textSecondary">
										{reactHtmlParser(attribute.formattedLabel)}
									</Typography>
								</TableCell>

								{attribute.value === 'vin' ? (
									<TableCell classes={tableCellClasses}>
										<Typography variant="body1" noWrap>
											{inputParameters.vinMin + ' to ' + inputParameters.vinMax + ' ' + attribute.unit}
										</Typography>
									</TableCell>
								) : attribute.value === 'isolated' ? (
									<TableCell classes={tableCellClasses}>
										<Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
											{inputParameters[attribute.value]
												? t('components.inputParameters.isolated')
												: t('components.inputParameters.nonIsolated')}
										</Typography>
									</TableCell>
								) : attribute.value === 'automotiveDesign' ? (
									<TableCell classes={tableCellClasses}>
										<Typography variant="body1">
											{inputParameters[attribute.value]
												? t('components.inputParameters.automotive')
												: t('components.inputParameters.automotiveAndIndustrial')}
										</Typography>
									</TableCell>
								) : (
									<TableCell classes={tableCellClasses}>
										<Typography variant="body1">{inputParameters[attribute.value] + ' ' + attribute.unit}</Typography>
									</TableCell>
								)}
							</TableRow>
						)
					)}
				</TableBody>
			</Table>
		</Card>
	);
};

InputParameters.propTypes = {
	inputParameters: PropTypes.object.isRequired,
	withChangeButton: PropTypes.bool,
	isVinNomSet: PropTypes.bool.isRequired
};

export default InputParameters;
